import { render, staticRenderFns } from "./link-button-group.vue?vue&type=template&id=1a7fc4c5&"
import script from "./link-button-group.vue?vue&type=script&lang=js&"
export * from "./link-button-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports